// extracted by mini-css-extract-plugin
export default {"guessBoard":"GuessBoard_guessBoard__lpu9a"};